import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'fz-dialog-message',
  templateUrl: './dialog-message.component.html',
  styleUrls: ['./dialog-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogMessageComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      image?: string;
      message: {
        title: string;
        content: string;
      };
      actions: { primaryAction: { label: string; handler: () => void } };
      status?: number;
    },
    public dialogRef: MatDialogRef<DialogMessageComponent>,
  ) {}
}
